import { Paragraph, TriangleExclamationIcon } from '@quickmd-llc/design-system';

export function PrepopulatedBanner() {
  return (
    <div className="flex items-center gap-2 rounded-lg border border-shade-20 bg-white p-2">
      <TriangleExclamationIcon iconSize="l" />
      <Paragraph className="font-semibold">
        We used answers from your last visit. Please review and make any needed
        changes.
      </Paragraph>
    </div>
  );
}
